import script from "./VideoDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./VideoDisplay.vue?vue&type=style&index=0&id=7b605b6a&lang=scss"

const __exports__ = script;

export default __exports__